import * as PIXI from "pixi.js";
import Game from "../Game";
import { getPolygonConDeltail } from "../types/config";
import { EventBus } from "../manager/eventBus";

interface Coord {
  x: number,
  y: number
}


export default class Polygon extends PIXI.Container {
  Game: Game;
  EventBus = EventBus
  bottomCon: PIXI.Container;
  topCon: PIXI.Container;
  nOfSide: number = 3;
  radius: number = 30;
  centerX: number;
  centerY: number;
  points: { x: number, y: number }[] = [];
  constructor() {
    super();
    this.Game = Game.getInstance();
    this.bottomCon = new PIXI.Container();
    this.bottomCon.x = 0;
    this.bottomCon.y = 0;
    this.topCon = new PIXI.Container();
    this.topCon.x = 0;
    this.topCon.y = 0;
    this.addChild(this.bottomCon, this.topCon);

    const { x, y, width, height } = getPolygonConDeltail(this.Game.getDim());

    this.centerX = x + width / 2;
    this.centerY = y + height / 2
    this.Game.middleContainer.addChild(this);

    this.EventBus.on("sideChange", (newAmountSide: number) => this.updateAmountOfSide(newAmountSide));
    this.EventBus.on("radiusChange", (newRadius: number) => this.updateRadius(newRadius));

    this.create();
  }

  create() {
    this.points = this.getPolygonPoints(this.radius);
    const gPoints = this.getPolygonPoints(1);
    this.points.forEach((coord, cI) => {
      const coord2 = this.points[cI == this.points.length - 1 ? 0 : cI + 1];
      const gCoord2 = gPoints[cI == gPoints.length - 1 ? 0 : cI + 1];

      this.createAngle(coord, coord2);
      this.createPoint(coord)
      this.createLine(coord, coord2, gPoints[cI], gCoord2)
    })

  }
  createPoint({ x, y }: Coord) {
    let r = 6
    if (this.radius < 50) {
      r = 1.5
    }
    const circle = new PIXI.Graphics()
      .circle(x, y, r)
      .fill(0x000000);
    this.topCon.addChild(circle);
  }

  createLine(cStart: Coord, cEnd: Coord, gCoord1: Coord, gCoord2: Coord) {
    let dx = cEnd.x - cStart.x;
    let dy = cEnd.y - cStart.y;

    if (this.radius == 0) {
      dx = gCoord2.x - gCoord1.x;
      dy = gCoord2.y - gCoord1.y;
    }

    let length = Math.sqrt(dx * dx + dy * dy);
    // Aynı doğrultuda 10 birim daha ilerlet
    const factor = (length + 40) / length;
    const extendedEndX = cStart.x + dx * factor;
    const extendedEndY = cStart.y + dy * factor;

    let graphics = new PIXI.Graphics()
      .moveTo(cStart.x, cStart.y)
      .lineTo(cEnd.x, cEnd.y)
      .lineTo(extendedEndX, extendedEndY)
      .stroke({ color: 0x000000, width: 3 });

    this.topCon.addChild(graphics);
  }
  getAngleBetweenPoints(cStart: Coord, cEnd: Coord): number {
    return Math.atan2(cEnd.y - cStart.y, cEnd.x - cStart.x);
  }
  createAngle(cStart: Coord, cEnd: Coord) {
    if (this.radius == 0) {
      const circle = new PIXI.Graphics()
        .circle(cStart.x, cStart.y, 26)
        .stroke({
          color: 0x000000,
          width: 6
        })
        .fill(0x3333dd);
      return this.bottomCon.addChild(circle)
    }
    const startAngle = this.getAngleBetweenPoints(cStart, cEnd);
    const arc2 = new PIXI.Graphics()
      .arc(cStart.x, cStart.y, 13, startAngle - (Math.PI / this.nOfSide) * 2, startAngle)
      .stroke({ width: 28, color: 0x3333dd });
    const arc22 = new PIXI.Graphics()
      .arc(cStart.x, cStart.y, 26, startAngle - (Math.PI / this.nOfSide) * 2, startAngle)
      .stroke({ width: 3, color: 0x000000 });
    this.bottomCon.addChild(arc2, arc22);
  }

  getPolygonPoints(radius: number) {
    const angleStep = (Math.PI * 2) / this.nOfSide; // Her bir kenar arasındaki açı
    const startAngle = -Math.PI / 2; // Başlangıç açısını -90 derece yapıyoruz (dairenin tepesi)
    let points: Coord[] = []
    for (let i = 0; i < this.nOfSide; i++) {
      const angle = startAngle + i * angleStep; // Açı hesaplama
      const x = this.centerX + radius * Math.cos(angle);
      const y = this.centerY + radius * Math.sin(angle);
      points.push({ x, y });
    }
    return points
  }
  clearContainer() {
    for (let i = 0; i < this.children.length; i++) {
      const con = this.children[i];
      for (let ii = 0; ii < con.children.length; ii++) {
        const c = con.children[ii] as PIXI.Graphics;
        c.clear();
      }
    }
    this.points = [];
  }
  updateAmountOfSide(newSideCount: number) {
    this.nOfSide = newSideCount;
    this.clearContainer();
    this.create();
  }
  updateRadius(newRadius: number) {
    this.radius = newRadius;
    this.clearContainer();
    this.create();
  }
}
